import type { BoardColumn } from '@scan2eat/shared';

/**
 * Column counts of the board, shared between the board page and the sidebar.
 *
 * The sidebar shows how many orders wait in NEW on every page. On the board
 * itself it reuses the counts the page already holds instead of fetching the
 * board a second time. Pure module state: no network call here.
 */

export type BoardCounts = Record<BoardColumn, number>;

type Listener = (counts: BoardCounts) => void;

const listeners = new Set<Listener>();
let latest: BoardCounts | null = null;

export function publishBoardCounts(counts: BoardCounts): void {
  latest = counts;
  for (const listener of listeners) listener(counts);
}

export function subscribeBoardCounts(listener: Listener): () => void {
  listeners.add(listener);
  if (latest) listener(latest);
  return () => {
    listeners.delete(listener);
  };
}
